
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TradeTransactionType} from '../core/TradeTransactionType';
import {FieldModelTradeTransactionType} from '../core/TradeTransactionType';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';
import {OrderSide} from '../core/OrderSide';
import {FieldModelOrderSide} from '../core/OrderSide';
import {OrderTimeInForce} from '../core/OrderTimeInForce';
import {FieldModelOrderTimeInForce} from '../core/OrderTimeInForce';
import {OrderStatus} from '../core/OrderStatus';
import {FieldModelOrderStatus} from '../core/OrderStatus';
import {TradeTransactionReason} from '../core/TradeTransactionReason';
import {FieldModelTradeTransactionReason} from '../core/TradeTransactionReason';

/**
 * TradeHistoryShortenedRecord struct
 */
class TradeHistoryShortenedRecord {
  /**
   * Initialize struct
   * @param {!number=} index
   * @param {number=} login
   * @param {string=} externalClientId
   * @param {string=} groupName
   * @param {number=} orderId
   * @param {string=} clientOrderId
   * @param {!TradeTransactionType=} transactionType
   * @param {string=} symbolName
   * @param {OrderType=} orderType
   * @param {OrderSide=} orderSide
   * @param {OrderTimeInForce=} orderTimeInForce
   * @param {OrderStatus=} orderStatus
   * @param {OrderType=} orderInitialType
   * @param {number=} openPrice
   * @param {number=} closePrice
   * @param {number=} limitPrice
   * @param {number=} stopPrice
   * @param {number=} takeProfit
   * @param {number=} stopLoss
   * @param {number=} amount
   * @param {number=} openAmount
   * @param {number=} closeAmount
   * @param {number=} executedAmount
   * @param {number=} remainingAmount
   * @param {number=} profit
   * @param {number=} profitConversionRate
   * @param {!TradeTransactionReason=} transactionReason
   * @param {string=} clientComment
   * @param {string=} managerComment
   * @param {number=} balanceMovement
   * @param {number=} balanceResult
   * @param {number=} commission
   * @param {number=} swap
   * @param {number=} openMarginRate
   * @param {number=} closeMarginRate
   * @param {Date=} createTimestamp
   * @param {Date=} modifyTimestamp
   * @param {Date=} openTimestamp
   * @param {Date=} closeTimestamp
   * @param {!Date=} transactionTimestamp
   * @constructor
   */
  constructor (index = new UInt64(0, 0), login = null, externalClientId = null, groupName = null, orderId = null, clientOrderId = null, transactionType = new TradeTransactionType(), symbolName = null, orderType = null, orderSide = null, orderTimeInForce = null, orderStatus = null, orderInitialType = null, openPrice = null, closePrice = null, limitPrice = null, stopPrice = null, takeProfit = null, stopLoss = null, amount = null, openAmount = null, closeAmount = null, executedAmount = null, remainingAmount = null, profit = null, profitConversionRate = null, transactionReason = new TradeTransactionReason(), clientComment = null, managerComment = null, balanceMovement = null, balanceResult = null, commission = null, swap = null, openMarginRate = null, closeMarginRate = null, createTimestamp = null, modifyTimestamp = null, openTimestamp = null, closeTimestamp = null, transactionTimestamp = new Date(0)) {
    this.Index = index
    this.Login = login
    this.ExternalClientId = externalClientId
    this.GroupName = groupName
    this.OrderId = orderId
    this.ClientOrderId = clientOrderId
    this.TransactionType = transactionType
    this.SymbolName = symbolName
    this.OrderType = orderType
    this.OrderSide = orderSide
    this.OrderTimeInForce = orderTimeInForce
    this.OrderStatus = orderStatus
    this.OrderInitialType = orderInitialType
    this.OpenPrice = openPrice
    this.ClosePrice = closePrice
    this.LimitPrice = limitPrice
    this.StopPrice = stopPrice
    this.TakeProfit = takeProfit
    this.StopLoss = stopLoss
    this.Amount = amount
    this.OpenAmount = openAmount
    this.CloseAmount = closeAmount
    this.ExecutedAmount = executedAmount
    this.RemainingAmount = remainingAmount
    this.Profit = profit
    this.ProfitConversionRate = profitConversionRate
    this.TransactionReason = transactionReason
    this.ClientComment = clientComment
    this.ManagerComment = managerComment
    this.BalanceMovement = balanceMovement
    this.BalanceResult = balanceResult
    this.Commission = commission
    this.Swap = swap
    this.OpenMarginRate = openMarginRate
    this.CloseMarginRate = closeMarginRate
    this.CreateTimestamp = createTimestamp
    this.ModifyTimestamp = modifyTimestamp
    this.OpenTimestamp = openTimestamp
    this.CloseTimestamp = closeTimestamp
    this.TransactionTimestamp = transactionTimestamp
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryShortenedRecord}
   * @param {!TradeHistoryShortenedRecord} other Other struct
   * @returns {!TradeHistoryShortenedRecord} This struct
   */
  copy (other) {
    if (other.Index != null) {
      this.Index = UInt64.fromNumber(other.Index)
    } else {
      this.Index = null
    }
    if (other.Login != null) {
      this.Login = UInt64.fromNumber(other.Login)
    } else {
      this.Login = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.GroupName != null) {
      this.GroupName = other.GroupName
    } else {
      this.GroupName = null
    }
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.ClientOrderId != null) {
      this.ClientOrderId = other.ClientOrderId
    } else {
      this.ClientOrderId = null
    }
    if (other.TransactionType != null) {
      this.TransactionType = TradeTransactionType.fromObject(other.TransactionType)
    } else {
      this.TransactionType = null
    }
    if (other.SymbolName != null) {
      this.SymbolName = other.SymbolName
    } else {
      this.SymbolName = null
    }
    if (other.OrderType != null) {
      this.OrderType = OrderType.fromObject(other.OrderType)
    } else {
      this.OrderType = null
    }
    if (other.OrderSide != null) {
      this.OrderSide = OrderSide.fromObject(other.OrderSide)
    } else {
      this.OrderSide = null
    }
    if (other.OrderTimeInForce != null) {
      this.OrderTimeInForce = OrderTimeInForce.fromObject(other.OrderTimeInForce)
    } else {
      this.OrderTimeInForce = null
    }
    if (other.OrderStatus != null) {
      this.OrderStatus = OrderStatus.fromObject(other.OrderStatus)
    } else {
      this.OrderStatus = null
    }
    if (other.OrderInitialType != null) {
      this.OrderInitialType = OrderType.fromObject(other.OrderInitialType)
    } else {
      this.OrderInitialType = null
    }
    if (other.OpenPrice != null) {
      this.OpenPrice = other.OpenPrice
    } else {
      this.OpenPrice = null
    }
    if (other.ClosePrice != null) {
      this.ClosePrice = other.ClosePrice
    } else {
      this.ClosePrice = null
    }
    if (other.LimitPrice != null) {
      this.LimitPrice = other.LimitPrice
    } else {
      this.LimitPrice = null
    }
    if (other.StopPrice != null) {
      this.StopPrice = other.StopPrice
    } else {
      this.StopPrice = null
    }
    if (other.TakeProfit != null) {
      this.TakeProfit = other.TakeProfit
    } else {
      this.TakeProfit = null
    }
    if (other.StopLoss != null) {
      this.StopLoss = other.StopLoss
    } else {
      this.StopLoss = null
    }
    if (other.Amount != null) {
      this.Amount = other.Amount
    } else {
      this.Amount = null
    }
    if (other.OpenAmount != null) {
      this.OpenAmount = other.OpenAmount
    } else {
      this.OpenAmount = null
    }
    if (other.CloseAmount != null) {
      this.CloseAmount = other.CloseAmount
    } else {
      this.CloseAmount = null
    }
    if (other.ExecutedAmount != null) {
      this.ExecutedAmount = other.ExecutedAmount
    } else {
      this.ExecutedAmount = null
    }
    if (other.RemainingAmount != null) {
      this.RemainingAmount = other.RemainingAmount
    } else {
      this.RemainingAmount = null
    }
    if (other.Profit != null) {
      this.Profit = other.Profit
    } else {
      this.Profit = null
    }
    if (other.ProfitConversionRate != null) {
      this.ProfitConversionRate = other.ProfitConversionRate
    } else {
      this.ProfitConversionRate = null
    }
    if (other.TransactionReason != null) {
      this.TransactionReason = TradeTransactionReason.fromObject(other.TransactionReason)
    } else {
      this.TransactionReason = null
    }
    if (other.ClientComment != null) {
      this.ClientComment = other.ClientComment
    } else {
      this.ClientComment = null
    }
    if (other.ManagerComment != null) {
      this.ManagerComment = other.ManagerComment
    } else {
      this.ManagerComment = null
    }
    if (other.BalanceMovement != null) {
      this.BalanceMovement = other.BalanceMovement
    } else {
      this.BalanceMovement = null
    }
    if (other.BalanceResult != null) {
      this.BalanceResult = other.BalanceResult
    } else {
      this.BalanceResult = null
    }
    if (other.Commission != null) {
      this.Commission = other.Commission
    } else {
      this.Commission = null
    }
    if (other.Swap != null) {
      this.Swap = other.Swap
    } else {
      this.Swap = null
    }
    if (other.OpenMarginRate != null) {
      this.OpenMarginRate = other.OpenMarginRate
    } else {
      this.OpenMarginRate = null
    }
    if (other.CloseMarginRate != null) {
      this.CloseMarginRate = other.CloseMarginRate
    } else {
      this.CloseMarginRate = null
    }
    if (other.CreateTimestamp != null) {
      if (other.CreateTimestamp instanceof Date) {
        this.CreateTimestamp = new Date(other.CreateTimestamp.getTime())
      } else {
        this.CreateTimestamp = new Date(Math.round(other.CreateTimestamp / 1000000))
      }
    } else {
      this.CreateTimestamp = null
    }
    if (other.ModifyTimestamp != null) {
      if (other.ModifyTimestamp instanceof Date) {
        this.ModifyTimestamp = new Date(other.ModifyTimestamp.getTime())
      } else {
        this.ModifyTimestamp = new Date(Math.round(other.ModifyTimestamp / 1000000))
      }
    } else {
      this.ModifyTimestamp = null
    }
    if (other.OpenTimestamp != null) {
      if (other.OpenTimestamp instanceof Date) {
        this.OpenTimestamp = new Date(other.OpenTimestamp.getTime())
      } else {
        this.OpenTimestamp = new Date(Math.round(other.OpenTimestamp / 1000000))
      }
    } else {
      this.OpenTimestamp = null
    }
    if (other.CloseTimestamp != null) {
      if (other.CloseTimestamp instanceof Date) {
        this.CloseTimestamp = new Date(other.CloseTimestamp.getTime())
      } else {
        this.CloseTimestamp = new Date(Math.round(other.CloseTimestamp / 1000000))
      }
    } else {
      this.CloseTimestamp = null
    }
    if (other.TransactionTimestamp != null) {
      if (other.TransactionTimestamp instanceof Date) {
        this.TransactionTimestamp = new Date(other.TransactionTimestamp.getTime())
      } else {
        this.TransactionTimestamp = new Date(Math.round(other.TransactionTimestamp / 1000000))
      }
    } else {
      this.TransactionTimestamp = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryShortenedRecord}
   * @returns {!TradeHistoryShortenedRecord} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryShortenedRecordModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryShortenedRecordModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryShortenedRecord}
   * @param {!TradeHistoryShortenedRecord} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryShortenedRecord)) {
      throw new TypeError('Instance of TradeHistoryShortenedRecord is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryShortenedRecord}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Index: ((this.Index != null) ? this.Index.toNumber() : null),
      Login: ((this.Login != null) ? this.Login.toNumber() : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      GroupName: ((this.GroupName != null) ? this.GroupName : null),
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      ClientOrderId: ((this.ClientOrderId != null) ? this.ClientOrderId : null),
      TransactionType: ((this.TransactionType != null) ? this.TransactionType : null),
      SymbolName: ((this.SymbolName != null) ? this.SymbolName : null),
      OrderType: ((this.OrderType != null) ? this.OrderType : null),
      OrderSide: ((this.OrderSide != null) ? this.OrderSide : null),
      OrderTimeInForce: ((this.OrderTimeInForce != null) ? this.OrderTimeInForce : null),
      OrderStatus: ((this.OrderStatus != null) ? this.OrderStatus : null),
      OrderInitialType: ((this.OrderInitialType != null) ? this.OrderInitialType : null),
      OpenPrice: ((this.OpenPrice != null) ? this.OpenPrice : null),
      ClosePrice: ((this.ClosePrice != null) ? this.ClosePrice : null),
      LimitPrice: ((this.LimitPrice != null) ? this.LimitPrice : null),
      StopPrice: ((this.StopPrice != null) ? this.StopPrice : null),
      TakeProfit: ((this.TakeProfit != null) ? this.TakeProfit : null),
      StopLoss: ((this.StopLoss != null) ? this.StopLoss : null),
      Amount: ((this.Amount != null) ? this.Amount : null),
      OpenAmount: ((this.OpenAmount != null) ? this.OpenAmount : null),
      CloseAmount: ((this.CloseAmount != null) ? this.CloseAmount : null),
      ExecutedAmount: ((this.ExecutedAmount != null) ? this.ExecutedAmount : null),
      RemainingAmount: ((this.RemainingAmount != null) ? this.RemainingAmount : null),
      Profit: ((this.Profit != null) ? this.Profit : null),
      ProfitConversionRate: ((this.ProfitConversionRate != null) ? this.ProfitConversionRate : null),
      TransactionReason: ((this.TransactionReason != null) ? this.TransactionReason : null),
      ClientComment: ((this.ClientComment != null) ? this.ClientComment : null),
      ManagerComment: ((this.ManagerComment != null) ? this.ManagerComment : null),
      BalanceMovement: ((this.BalanceMovement != null) ? this.BalanceMovement : null),
      BalanceResult: ((this.BalanceResult != null) ? this.BalanceResult : null),
      Commission: ((this.Commission != null) ? this.Commission : null),
      Swap: ((this.Swap != null) ? this.Swap : null),
      OpenMarginRate: ((this.OpenMarginRate != null) ? this.OpenMarginRate : null),
      CloseMarginRate: ((this.CloseMarginRate != null) ? this.CloseMarginRate : null),
      CreateTimestamp: ((this.CreateTimestamp != null) ? (this.CreateTimestamp.getTime() * 1000000) : null),
      ModifyTimestamp: ((this.ModifyTimestamp != null) ? (this.ModifyTimestamp.getTime() * 1000000) : null),
      OpenTimestamp: ((this.OpenTimestamp != null) ? (this.OpenTimestamp.getTime() * 1000000) : null),
      CloseTimestamp: ((this.CloseTimestamp != null) ? (this.CloseTimestamp.getTime() * 1000000) : null),
      TransactionTimestamp: ((this.TransactionTimestamp != null) ? (this.TransactionTimestamp.getTime() * 1000000) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryShortenedRecord.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryShortenedRecord} other Object value
   * @returns {!TradeHistoryShortenedRecord} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryShortenedRecord().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryShortenedRecord}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryShortenedRecord.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryShortenedRecord}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6619
  }
}

export { TradeHistoryShortenedRecord };

/**
 * Fast Binary Encoding TradeHistoryShortenedRecord field model
 */
class FieldModelTradeHistoryShortenedRecord extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Index = new fbe.FieldModelUInt64(buffer, 4 + 4)
    this.Login = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.Index.fbeOffset + this.Index.fbeSize), buffer, this.Index.fbeOffset + this.Index.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Login.fbeOffset + this.Login.fbeSize), buffer, this.Login.fbeOffset + this.Login.fbeSize)
    this.GroupName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize), buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
    this.OrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.GroupName.fbeOffset + this.GroupName.fbeSize), buffer, this.GroupName.fbeOffset + this.GroupName.fbeSize)
    this.ClientOrderId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.TransactionType = new FieldModelTradeTransactionType(buffer, this.ClientOrderId.fbeOffset + this.ClientOrderId.fbeSize)
    this.SymbolName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize), buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize)
    this.OrderType = new fbe.FieldModelOptional(new FieldModelOrderType(buffer, this.SymbolName.fbeOffset + this.SymbolName.fbeSize), buffer, this.SymbolName.fbeOffset + this.SymbolName.fbeSize)
    this.OrderSide = new fbe.FieldModelOptional(new FieldModelOrderSide(buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize), buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize)
    this.OrderTimeInForce = new fbe.FieldModelOptional(new FieldModelOrderTimeInForce(buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize), buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize)
    this.OrderStatus = new fbe.FieldModelOptional(new FieldModelOrderStatus(buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize), buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize)
    this.OrderInitialType = new fbe.FieldModelOptional(new FieldModelOrderType(buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize), buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize)
    this.OpenPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize), buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize)
    this.ClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenPrice.fbeOffset + this.OpenPrice.fbeSize), buffer, this.OpenPrice.fbeOffset + this.OpenPrice.fbeSize)
    this.LimitPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize), buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize)
    this.StopPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.LimitPrice.fbeOffset + this.LimitPrice.fbeSize), buffer, this.LimitPrice.fbeOffset + this.LimitPrice.fbeSize)
    this.TakeProfit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.StopPrice.fbeOffset + this.StopPrice.fbeSize), buffer, this.StopPrice.fbeOffset + this.StopPrice.fbeSize)
    this.StopLoss = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.TakeProfit.fbeOffset + this.TakeProfit.fbeSize), buffer, this.TakeProfit.fbeOffset + this.TakeProfit.fbeSize)
    this.Amount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.StopLoss.fbeOffset + this.StopLoss.fbeSize), buffer, this.StopLoss.fbeOffset + this.StopLoss.fbeSize)
    this.OpenAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Amount.fbeOffset + this.Amount.fbeSize), buffer, this.Amount.fbeOffset + this.Amount.fbeSize)
    this.CloseAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenAmount.fbeOffset + this.OpenAmount.fbeSize), buffer, this.OpenAmount.fbeOffset + this.OpenAmount.fbeSize)
    this.ExecutedAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize), buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize)
    this.RemainingAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize), buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize)
    this.Profit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize), buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize)
    this.ProfitConversionRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Profit.fbeOffset + this.Profit.fbeSize), buffer, this.Profit.fbeOffset + this.Profit.fbeSize)
    this.TransactionReason = new FieldModelTradeTransactionReason(buffer, this.ProfitConversionRate.fbeOffset + this.ProfitConversionRate.fbeSize)
    this.ClientComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize), buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize)
    this.ManagerComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ClientComment.fbeOffset + this.ClientComment.fbeSize), buffer, this.ClientComment.fbeOffset + this.ClientComment.fbeSize)
    this.BalanceMovement = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize), buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize)
    this.BalanceResult = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.BalanceMovement.fbeOffset + this.BalanceMovement.fbeSize), buffer, this.BalanceMovement.fbeOffset + this.BalanceMovement.fbeSize)
    this.Commission = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.BalanceResult.fbeOffset + this.BalanceResult.fbeSize), buffer, this.BalanceResult.fbeOffset + this.BalanceResult.fbeSize)
    this.Swap = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Commission.fbeOffset + this.Commission.fbeSize), buffer, this.Commission.fbeOffset + this.Commission.fbeSize)
    this.OpenMarginRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Swap.fbeOffset + this.Swap.fbeSize), buffer, this.Swap.fbeOffset + this.Swap.fbeSize)
    this.CloseMarginRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenMarginRate.fbeOffset + this.OpenMarginRate.fbeSize), buffer, this.OpenMarginRate.fbeOffset + this.OpenMarginRate.fbeSize)
    this.CreateTimestamp = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize), buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize)
    this.ModifyTimestamp = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.CreateTimestamp.fbeOffset + this.CreateTimestamp.fbeSize), buffer, this.CreateTimestamp.fbeOffset + this.CreateTimestamp.fbeSize)
    this.OpenTimestamp = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.ModifyTimestamp.fbeOffset + this.ModifyTimestamp.fbeSize), buffer, this.ModifyTimestamp.fbeOffset + this.ModifyTimestamp.fbeSize)
    this.CloseTimestamp = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.OpenTimestamp.fbeOffset + this.OpenTimestamp.fbeSize), buffer, this.OpenTimestamp.fbeOffset + this.OpenTimestamp.fbeSize)
    this.TransactionTimestamp = new fbe.FieldModelTimestamp(buffer, this.CloseTimestamp.fbeOffset + this.CloseTimestamp.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Index.fbeSize + this.Login.fbeSize + this.ExternalClientId.fbeSize + this.GroupName.fbeSize + this.OrderId.fbeSize + this.ClientOrderId.fbeSize + this.TransactionType.fbeSize + this.SymbolName.fbeSize + this.OrderType.fbeSize + this.OrderSide.fbeSize + this.OrderTimeInForce.fbeSize + this.OrderStatus.fbeSize + this.OrderInitialType.fbeSize + this.OpenPrice.fbeSize + this.ClosePrice.fbeSize + this.LimitPrice.fbeSize + this.StopPrice.fbeSize + this.TakeProfit.fbeSize + this.StopLoss.fbeSize + this.Amount.fbeSize + this.OpenAmount.fbeSize + this.CloseAmount.fbeSize + this.ExecutedAmount.fbeSize + this.RemainingAmount.fbeSize + this.Profit.fbeSize + this.ProfitConversionRate.fbeSize + this.TransactionReason.fbeSize + this.ClientComment.fbeSize + this.ManagerComment.fbeSize + this.BalanceMovement.fbeSize + this.BalanceResult.fbeSize + this.Commission.fbeSize + this.Swap.fbeSize + this.OpenMarginRate.fbeSize + this.CloseMarginRate.fbeSize + this.CreateTimestamp.fbeSize + this.ModifyTimestamp.fbeSize + this.OpenTimestamp.fbeSize + this.CloseTimestamp.fbeSize + this.TransactionTimestamp.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Index.fbeExtra + this.Login.fbeExtra + this.ExternalClientId.fbeExtra + this.GroupName.fbeExtra + this.OrderId.fbeExtra + this.ClientOrderId.fbeExtra + this.TransactionType.fbeExtra + this.SymbolName.fbeExtra + this.OrderType.fbeExtra + this.OrderSide.fbeExtra + this.OrderTimeInForce.fbeExtra + this.OrderStatus.fbeExtra + this.OrderInitialType.fbeExtra + this.OpenPrice.fbeExtra + this.ClosePrice.fbeExtra + this.LimitPrice.fbeExtra + this.StopPrice.fbeExtra + this.TakeProfit.fbeExtra + this.StopLoss.fbeExtra + this.Amount.fbeExtra + this.OpenAmount.fbeExtra + this.CloseAmount.fbeExtra + this.ExecutedAmount.fbeExtra + this.RemainingAmount.fbeExtra + this.Profit.fbeExtra + this.ProfitConversionRate.fbeExtra + this.TransactionReason.fbeExtra + this.ClientComment.fbeExtra + this.ManagerComment.fbeExtra + this.BalanceMovement.fbeExtra + this.BalanceResult.fbeExtra + this.Commission.fbeExtra + this.Swap.fbeExtra + this.OpenMarginRate.fbeExtra + this.CloseMarginRate.fbeExtra + this.CreateTimestamp.fbeExtra + this.ModifyTimestamp.fbeExtra + this.OpenTimestamp.fbeExtra + this.CloseTimestamp.fbeExtra + this.TransactionTimestamp.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryShortenedRecord.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6619
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Index.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Index.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Index.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.GroupName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GroupName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupName.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.SymbolName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolName.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderSide.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTimeInForce.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStatus.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderInitialType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.LimitPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LimitPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LimitPrice.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TakeProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Amount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExecutedAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RemainingAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Profit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Profit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Profit.fbeSize

    if ((fbeCurrentSize + this.ProfitConversionRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ProfitConversionRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitConversionRate.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionReason.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ClientComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.BalanceMovement.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BalanceMovement.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceMovement.fbeSize

    if ((fbeCurrentSize + this.BalanceResult.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BalanceResult.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceResult.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Commission.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.Swap.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Swap.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Swap.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.CreateTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CreateTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CreateTimestamp.fbeSize

    if ((fbeCurrentSize + this.ModifyTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ModifyTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ModifyTimestamp.fbeSize

    if ((fbeCurrentSize + this.OpenTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenTimestamp.fbeSize

    if ((fbeCurrentSize + this.CloseTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseTimestamp.fbeSize

    if ((fbeCurrentSize + this.TransactionTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTimestamp.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!TradeHistoryShortenedRecord} fbeValue Default value, defaults is new TradeHistoryShortenedRecord()
   * @returns {!TradeHistoryShortenedRecord} TradeHistoryShortenedRecord value
   */
  get (fbeValue = new TradeHistoryShortenedRecord()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!TradeHistoryShortenedRecord} fbeValue TradeHistoryShortenedRecord value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Index.fbeSize) <= fbeStructSize) {
      fbeValue.Index = this.Index.get()
    } else {
      fbeValue.Index = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Index.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.GroupName.fbeSize) <= fbeStructSize) {
      fbeValue.GroupName = this.GroupName.get()
    } else {
      fbeValue.GroupName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupName.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.ClientOrderId = this.ClientOrderId.get()
    } else {
      fbeValue.ClientOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionType = this.TransactionType.get()
    } else {
      fbeValue.TransactionType = new TradeTransactionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.SymbolName.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolName = this.SymbolName.get()
    } else {
      fbeValue.SymbolName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolName.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderType = this.OrderType.get()
    } else {
      fbeValue.OrderType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) <= fbeStructSize) {
      fbeValue.OrderSide = this.OrderSide.get()
    } else {
      fbeValue.OrderSide = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) <= fbeStructSize) {
      fbeValue.OrderTimeInForce = this.OrderTimeInForce.get()
    } else {
      fbeValue.OrderTimeInForce = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) <= fbeStructSize) {
      fbeValue.OrderStatus = this.OrderStatus.get()
    } else {
      fbeValue.OrderStatus = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderInitialType = this.OrderInitialType.get()
    } else {
      fbeValue.OrderInitialType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) <= fbeStructSize) {
      fbeValue.OpenPrice = this.OpenPrice.get()
    } else {
      fbeValue.OpenPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.ClosePrice = this.ClosePrice.get()
    } else {
      fbeValue.ClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.LimitPrice.fbeSize) <= fbeStructSize) {
      fbeValue.LimitPrice = this.LimitPrice.get()
    } else {
      fbeValue.LimitPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LimitPrice.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) <= fbeStructSize) {
      fbeValue.StopPrice = this.StopPrice.get()
    } else {
      fbeValue.StopPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) <= fbeStructSize) {
      fbeValue.TakeProfit = this.TakeProfit.get()
    } else {
      fbeValue.TakeProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) <= fbeStructSize) {
      fbeValue.StopLoss = this.StopLoss.get()
    } else {
      fbeValue.StopLoss = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) <= fbeStructSize) {
      fbeValue.Amount = this.Amount.get()
    } else {
      fbeValue.Amount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAmount = this.OpenAmount.get()
    } else {
      fbeValue.OpenAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.CloseAmount = this.CloseAmount.get()
    } else {
      fbeValue.CloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) <= fbeStructSize) {
      fbeValue.ExecutedAmount = this.ExecutedAmount.get()
    } else {
      fbeValue.ExecutedAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) <= fbeStructSize) {
      fbeValue.RemainingAmount = this.RemainingAmount.get()
    } else {
      fbeValue.RemainingAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Profit.fbeSize) <= fbeStructSize) {
      fbeValue.Profit = this.Profit.get()
    } else {
      fbeValue.Profit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Profit.fbeSize

    if ((fbeCurrentSize + this.ProfitConversionRate.fbeSize) <= fbeStructSize) {
      fbeValue.ProfitConversionRate = this.ProfitConversionRate.get()
    } else {
      fbeValue.ProfitConversionRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitConversionRate.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionReason = this.TransactionReason.get()
    } else {
      fbeValue.TransactionReason = new TradeTransactionReason()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ClientComment.fbeSize) <= fbeStructSize) {
      fbeValue.ClientComment = this.ClientComment.get()
    } else {
      fbeValue.ClientComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerComment = this.ManagerComment.get()
    } else {
      fbeValue.ManagerComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.BalanceMovement.fbeSize) <= fbeStructSize) {
      fbeValue.BalanceMovement = this.BalanceMovement.get()
    } else {
      fbeValue.BalanceMovement = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceMovement.fbeSize

    if ((fbeCurrentSize + this.BalanceResult.fbeSize) <= fbeStructSize) {
      fbeValue.BalanceResult = this.BalanceResult.get()
    } else {
      fbeValue.BalanceResult = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceResult.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) <= fbeStructSize) {
      fbeValue.Commission = this.Commission.get()
    } else {
      fbeValue.Commission = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.Swap.fbeSize) <= fbeStructSize) {
      fbeValue.Swap = this.Swap.get()
    } else {
      fbeValue.Swap = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Swap.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarginRate = this.OpenMarginRate.get()
    } else {
      fbeValue.OpenMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.CloseMarginRate = this.CloseMarginRate.get()
    } else {
      fbeValue.CloseMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.CreateTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.CreateTimestamp = this.CreateTimestamp.get()
    } else {
      fbeValue.CreateTimestamp = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CreateTimestamp.fbeSize

    if ((fbeCurrentSize + this.ModifyTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.ModifyTimestamp = this.ModifyTimestamp.get()
    } else {
      fbeValue.ModifyTimestamp = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ModifyTimestamp.fbeSize

    if ((fbeCurrentSize + this.OpenTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.OpenTimestamp = this.OpenTimestamp.get()
    } else {
      fbeValue.OpenTimestamp = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenTimestamp.fbeSize

    if ((fbeCurrentSize + this.CloseTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.CloseTimestamp = this.CloseTimestamp.get()
    } else {
      fbeValue.CloseTimestamp = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseTimestamp.fbeSize

    if ((fbeCurrentSize + this.TransactionTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionTimestamp = this.TransactionTimestamp.get()
    } else {
      fbeValue.TransactionTimestamp = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTimestamp.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {!TradeHistoryShortenedRecord} fbeValue TradeHistoryShortenedRecord value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryShortenedRecord}
   * @param {TradeHistoryShortenedRecord} fbeValue TradeHistoryShortenedRecord value
   */
  setFields (fbeValue) {
    this.Index.set(fbeValue.Index)
    this.Login.set(fbeValue.Login)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.GroupName.set(fbeValue.GroupName)
    this.OrderId.set(fbeValue.OrderId)
    this.ClientOrderId.set(fbeValue.ClientOrderId)
    this.TransactionType.set(fbeValue.TransactionType)
    this.SymbolName.set(fbeValue.SymbolName)
    this.OrderType.set(fbeValue.OrderType)
    this.OrderSide.set(fbeValue.OrderSide)
    this.OrderTimeInForce.set(fbeValue.OrderTimeInForce)
    this.OrderStatus.set(fbeValue.OrderStatus)
    this.OrderInitialType.set(fbeValue.OrderInitialType)
    this.OpenPrice.set(fbeValue.OpenPrice)
    this.ClosePrice.set(fbeValue.ClosePrice)
    this.LimitPrice.set(fbeValue.LimitPrice)
    this.StopPrice.set(fbeValue.StopPrice)
    this.TakeProfit.set(fbeValue.TakeProfit)
    this.StopLoss.set(fbeValue.StopLoss)
    this.Amount.set(fbeValue.Amount)
    this.OpenAmount.set(fbeValue.OpenAmount)
    this.CloseAmount.set(fbeValue.CloseAmount)
    this.ExecutedAmount.set(fbeValue.ExecutedAmount)
    this.RemainingAmount.set(fbeValue.RemainingAmount)
    this.Profit.set(fbeValue.Profit)
    this.ProfitConversionRate.set(fbeValue.ProfitConversionRate)
    this.TransactionReason.set(fbeValue.TransactionReason)
    this.ClientComment.set(fbeValue.ClientComment)
    this.ManagerComment.set(fbeValue.ManagerComment)
    this.BalanceMovement.set(fbeValue.BalanceMovement)
    this.BalanceResult.set(fbeValue.BalanceResult)
    this.Commission.set(fbeValue.Commission)
    this.Swap.set(fbeValue.Swap)
    this.OpenMarginRate.set(fbeValue.OpenMarginRate)
    this.CloseMarginRate.set(fbeValue.CloseMarginRate)
    this.CreateTimestamp.set(fbeValue.CreateTimestamp)
    this.ModifyTimestamp.set(fbeValue.ModifyTimestamp)
    this.OpenTimestamp.set(fbeValue.OpenTimestamp)
    this.CloseTimestamp.set(fbeValue.CloseTimestamp)
    this.TransactionTimestamp.set(fbeValue.TransactionTimestamp)
  }
}

export { FieldModelTradeHistoryShortenedRecord };

/**
 * Fast Binary Encoding TradeHistoryShortenedRecord model
 */
class TradeHistoryShortenedRecordModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryShortenedRecord(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryShortenedRecord model
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!FieldModelTradeHistoryShortenedRecord} model TradeHistoryShortenedRecord model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryShortenedRecordModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryShortenedRecord.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryShortenedRecordModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryShortenedRecordModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryShortenedRecordModel}
   * @param {!TradeHistoryShortenedRecord} value TradeHistoryShortenedRecord value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryShortenedRecordModel}
   * @param {!TradeHistoryShortenedRecord} value TradeHistoryShortenedRecord value, defaults is new TradeHistoryShortenedRecord()
   * @return {!object} Deserialized TradeHistoryShortenedRecord value and its size
   */
  deserialize (value = new TradeHistoryShortenedRecord()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryShortenedRecord(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryShortenedRecord(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryShortenedRecordModel}
   * @param {!number} prev Previous TradeHistoryShortenedRecord model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryShortenedRecordModel };
